import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import jsonpath from 'jsonpath';
// Example utility functions
function extractData(json, path) {
  const result = jsonpath.query(json, path);
  return result?.[0] || '';
}
function getString(tableData) {
    let remarks = [];
  
    // tableData.forEach((sample) => {
    //   sample.Checksheet?.forEach((cs, idx) => {
    //     if (cs?.Remarks) {
    //       remarks.push(`Row ${idx + 1}: ${cs.Remarks}`);
    //     }
    //   });
    // });
  
    return remarks.join(' | ') || '-';
  }
  
  

// Main function to be called programmatically
export const generateAllReports = async (yearlyData = []) => {
  for (let i = 0; i < yearlyData.length; i++) {
    const { pdfData = [], data = {}, company,DateTime } = yearlyData[i];
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a2',
    });
    const tableHeaders = [
      [
        { content: `Part Name: `, colSpan: 4, styles: { halign: 'left', cellPadding: 1 } },
        { content: `${data.Item}`, colSpan: 4, styles: { halign: 'left', cellPadding: 1 } },
        {
          content: "DAILY INITIAL FLOW MANAGEMENT CONTROL ITEMS MONITORING CHECKSHEET ( PART )",
          colSpan: pdfData.length === 0 ? 1 : pdfData.length + 1,
          rowSpan: 4,
          styles: { halign: 'center', valign: 'middle' }
        },
        {
          content: `DATE: ${moment(data.DateTime).format('DD-MM-YYYY')}`,
          rowSpan: 4,
          styles: { halign: 'center', cellWidth: 13, cellPadding: 1 }
        }
      ],
      [
        { content: `Part No: `, colSpan: 4, styles: { halign: 'left', cellPadding: 1 } },
        { content: `${data.ItemNumber}`, colSpan: 4, styles: { halign: 'left', cellPadding: 1 } },
      ],
      [
        { content: `Model:`, colSpan: 4, styles: { halign: 'left', cellPadding: 1 } },
        { content: `${extractData(data, '$..customFields[?(@.FieldName=="Model")].Value')}`, colSpan: 4, styles: { halign: 'left', cellPadding: 1 } },
      ],
      [
        { content: `Vendor:`, colSpan: 4, styles: { halign: 'left', cellPadding: 1 } },
        { content: `${extractData(data, '$..customFields[?(@.FieldName=="Vendor")].Value')}`, colSpan: 4, styles: { halign: 'left', cellPadding: 1 } },
      ],
      [
        { content: 'S.No', rowSpan: 3, styles: { halign: 'center', cellWidth: 5, cellPadding: 1 } },
        { content: 'Stage', rowSpan: 3, styles: { halign: 'center', cellWidth: 15, cellPadding: 1 } },
        { content: 'MISP Sr.No.', rowSpan: 3, styles: { halign: 'center', cellWidth: 13, cellPadding: 1 } },
        { content: 'MISP Page No.', rowSpan: 3, styles: { halign: 'center', cellWidth: 13, cellPadding: 1 } },
        { content: 'Control Items', rowSpan: 3, styles: { halign: 'center', cellWidth: 20, cellPadding: 1 } },
        { content: 'Content', rowSpan: 3, styles: { halign: 'center', cellWidth: 30, cellPadding: 1 } },
        { content: 'Process Capability Applicable (Yes/No)', rowSpan: 3, styles: { halign: 'center', cellWidth: 15, cellPadding: 1 } },
        { content: 'CHECKING METHODS', rowSpan: 3, styles: { halign: 'center', cellWidth: 15, cellPadding: 1 } },
        { content: 'Normal Frequency', rowSpan: 3, styles: { halign: 'center', cellWidth: 15, cellPadding: 1 } },
        { content: 'IFM Frequency', rowSpan: 3, styles: { halign: 'center', cellWidth: 15, cellPadding: 1 } },
        {
          content: 'Result',
          colSpan: pdfData.length <= 1 ? 1 : pdfData.length + 1,
          styles: { halign: 'center', cellPadding: 1 }
        }
      ],
      [
        ...pdfData.map((_, index) => ({
          content: `${_.sampleRef?.[0]?.Sample?.split('Sample')[1] || "-"}`,
          styles: { halign: 'center',  cellPadding: 1, 
            cellWidth: 14}
        }))
      ],
      [
        ...pdfData.map((sample) => ({
          content: extractData(sample, '$..customFields[?(@.FieldName=="Sample ID")].Value') || "-",
          styles: { halign: 'center', cellPadding: 1, 
            cellWidth: 14}
        }))
      ]
    ];
    const tableBody = data.Checksheet.map((one, idx) => ([
      idx + 1,
      one.Stage,
      one.MISP_SrNo,
      one.MISP_Page_No,
      one.Control_Items,
      one.Content,
      "", // Process Capability
      one.Checking_Methods,
      one.Normal_Frequency,
      one.IFM_Frequency,
      ...pdfData.map(sample =>
        sample.Checksheet?.[idx]?.StandardType === 'Dimension'
          ? sample.Checksheet[idx]?.Data?.[0]?.Observed_Value || ''
          : sample.Checksheet[idx]?.Data?.[0]?.Result || ''
      )
    ]));
    const tableFooter = [
      [
        { content: 'Note - Marking is Required on first 5000 Parts or for first 3 months whichever is earlier', colSpan: 3, styles: { halign: 'center', cellPadding: 1 } },
        { content: '', colSpan: 7 + pdfData.length, styles: { cellPadding: 1 } },
      ],
      [
        { content: 'CHECKED BY', colSpan: 3, styles: { halign: 'center', cellPadding: 1 } },
        { content: extractData(data, '$..customFields[?(@.FieldName=="Checked By")].Value'), colSpan: 7 + pdfData.length, styles: { halign: 'center', cellPadding: 1 } },
      ],
      [
        { content: 'VERIFIED BY', colSpan: 3, styles: { halign: 'center', cellPadding: 1 } },
        { content: '', colSpan: 7 + pdfData.length, styles: { halign: 'center', cellPadding: 1 } },
      ],
      [
        { content: 'APPROVED', colSpan: 3, styles: { halign: 'center', cellPadding: 1 } },
        { content: '', colSpan: 7 + pdfData.length, styles: { halign: 'center', cellPadding: 1 } },
      ],
      [
        { content: 'REMARKS', colSpan: 3, styles: { halign: 'center', cellPadding: 1 } },
        { content: getString(pdfData), colSpan: 7 + pdfData.length, styles: { halign: 'center', cellPadding: 1 } },
      ],
    ];
    doc.autoTable({
        head: tableHeaders,
        body: tableBody,
        foot: tableFooter,
        startY: 0, // 👈 Start from the very top (remove startY:10)
        margin: { top: 2, left: 2, right: 2, bottom: 2 }, // 👈 No margins
        theme: 'striped',
        styles: {
          fontSize: 8,
          cellPadding: 2,
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
        },
        footStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
        },
      });
      
    const fileName = `Daily_IFM_${data.Item}_${moment(DateTime).format("DD-MM-YYYY")}.pdf`;
    doc.save(fileName);
    // You can add a delay if needed to avoid freezing browser:
    // await new Promise(res => setTimeout(res, 100));
  }
};